import { RouterProvider } from "@tanstack/react-router"
import { extend } from "dayjs"
import utc from "dayjs/plugin/utc"
import { createRoot } from "react-dom/client"
import { AppContext } from "./contexts"
import "./index.scss"
import { router } from "./router"
import { applicationInsights } from "src/utils"

extend(utc)

const root = createRoot(
  document.getElementById("root") as HTMLElement,
)

root.render(
  <AppContext>
    <RouterProvider router={router} />
  </AppContext>,
)

applicationInsights.loadAppInsights()
applicationInsights.trackPageView()
